export const sandboxBaseUrl = process.env.NUXT_SANDBOX_BASE_URL
export const prodBaseUrl = process.env.NUXT_BASE_URL

const ENVS = {
  LOCAL: 'local',
  SANDBOX: 'sandbox',
  PROD: 'production',
  TEST: 'test',
}

const Environments = {
  Sandbox: {
    name: 'Sandbox',
    env: 'sandbox',
    apiHost: sandboxBaseUrl,
  },
  Prod: {
    name: 'Production',
    env: 'production',
    apiHost: prodBaseUrl,
  },
  Local: {
    name: 'Local',
    env: 'local',
    apiHost: '',
  },
  TEST: {
    name: 'Test',
    env: 'test',
    apiHost: '',
  },
}

const Environment = {
  current: Environments.Prod,
}

const ENV_MATCHERS = {
  [ENVS.LOCAL]: ['localhost', '127.0.0.1'],
  [ENVS.TEST]: ['test', 'staged', 'v2.'],
  [ENVS.SANDBOX]: ['sandbox'],
  [ENVS.PROD]: ['app', 'base'],
}

const isEnv = (hostUrl: string, environment: string): boolean => {
  const matchers = ENV_MATCHERS[environment]

  if (!matchers) {
    throw new Error('Critical: Error initializing environment')
  }

  return !!matchers.find((match) => hostUrl.includes(match))
}

const initEnv = (host: string) => {
  if (isEnv(host, ENVS.LOCAL)) {
    Environment.current = Environments.Local
    return ENVS.LOCAL
  }

  if (isEnv(host, ENVS.SANDBOX)) {
    Environment.current = Environments.Sandbox
    return ENVS.SANDBOX
  }

  if (isEnv(host, ENVS.TEST)) {
    Environment.current = Environments.TEST
    return ENVS.TEST
  }

  Environment.current = Environments.Prod
  return ENVS.PROD
}

const reloadEnvironmentConfig = (env: string = '') =>
  import.meta.client && initEnv(env || window.location.host)

reloadEnvironmentConfig()

export { Environment, Environments, reloadEnvironmentConfig, isEnv, initEnv }
